<template>
  <div class="mobiletCheckout">
    <div class="header">提交订单</div>
    <Address/>
    <tInfo :order="order"/>
    <div class="checkoutFooter clearfix">
      <div class="left">
        <p>
          <span>合计:¥</span>
          {{order.amount}}
        </p>
      </div>
      <div class="right">
        <button @click="Pay">立即支付</button>
      </div>
    </div>
  </div>
</template>

<script>
import Address from "@/components/Mobile/Checkout/Address.vue";
import tInfo from "@/components/Mobile/tCheckout/Info.vue";

export default {
  name: "Order",
  data() {
    return {
      active: 2,
      ordersn: {},
      checked: true,
      payType: "1",
      url: ""
    };
  },
  components: {
    Address,
    tInfo
  },
  mounted: function() {
    if (navigator.appVersion.indexOf("MicroMessenger") > -1) {
      this.payType = "1";
    } else {
      this.payType = "2";
    }
  },
  computed: {
    payUrl() {
      return this.$store.state.alipay.alipayurl;
    },
    WechatWap() {
      return this.$store.state.wechat.wechatwap;
    },
    order() {
      return this.$store.state.order.orderdata;
    },
    product() {
      return this.$store.state.product.product;
    },
    wechatauthor() {
      return this.$store.state.wechat.wechatauthor;
    }
  },
  methods: {
    Pay() {
      var browser = {
        versions: (function() {
          var u = window.navigator.userAgent;
          return {
            trident: u.indexOf("Trident") > -1, //IE内核
            presto: u.indexOf("Presto") > -1, //opera内核
            webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
            gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
            mobile:
              !!u.match(/AppleWebKit.*Mobile.*/) || !!u.match(/AppleWebKit/), //是否为移动终端
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或者uc浏览器
            iPhone: u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1, //是否为iPhone或者安卓QQ浏览器
            iPad: u.indexOf("iPad") > -1, //是否为iPad
            webApp: u.indexOf("Safari") == -1, //是否为web应用程序，没有头部与底部
            weixin: u.indexOf("MicroMessenger") == -1 //是否为微信浏览器
          };
        })()
      };
      if(!this.order.ordersn){
        this.$toast("订单数据不存在.");
        return false;
      }
      if (navigator.userAgent.match(/MicroMessenger/i) == 'MicroMessenger') {
        this.WechatPay();
      }else{
        this.AliPay();
      }
    },
    AliPay() {
      let params = {
        paySource: "mobile",
        ordersn: this.order.ordersn,
        amount: this.order.amount,
        goodsName: this.order.goodsname
      };
      this.$store.dispatch("alipay/fetchAlipayWap", { params }).then(() => {
        const div = document.createElement("div");
        div.innerHTML = this.$store.state.alipay.alipaywap;
        document.body.appendChild(div);
        document.forms[0].submit();
      });
    },
    WechatPay() {
      let url =
        "https://www.suhuishou.com/api/wechat/mp?ordersn=" +
        this.order.ordersn +
        "&openId=" +
        this.wechatauthor.openid;
      this.url = url;
      window.location = url;
    },
    WechatPayH5() {
      let params = {};
      this.$store.dispatch("wechat/fetchWechatPayH5", { params }).then(() => {
        let data = this.$store.state.wechat.payh5;
        let url =
          data.mweb_url + "&redirect_url=https%3A%2F%2Fwww.suhuishou.com";
        this.url = url;
        window.location = url;
      });
    },
    changePayType(value) {
      this.payType = value;
    }
  },
  created() {}
};
</script>
<style>
.mobiletCheckout {
  background: #fff;
  padding: 0rem 0 1rem;
}
.mobiletCheckout .header {
  height: 0.44rem;
  line-height: 0.44rem;
  text-align: center;
  position: relative;
  background: #fff;
}
.mobiletCheckout .header .header-left {
  position: absolute;
  left: 0.1rem;
  top: 0.23rem;
}
.mobiletCheckout .checkoutFooter {
  box-shadow: #efefef 0 0 0.1rem;
  height: 0.63rem;
  position: fixed;
  width: 100%;
  background: #fff;
  bottom: 0;
  left: 0;
}
.mobiletCheckout .checkoutFooter .left {
  float: left;
  padding: 0.12rem 0 0 0;
}
.mobiletCheckout .checkoutFooter .left p {
  font-size: 0.2rem;
  margin-left: 0.14rem;
  line-height: 0.3rem;
  color: #f9415d;
}
.mobiletCheckout .checkoutFooter .left p span {
  font-size: 0.12rem;
}
.mobiletCheckout .checkoutFooter .left p:nth-child(2) {
  color: #999;
  margin-top: 0.02rem;
}
.mobiletCheckout .checkoutFooter .right {
  float: right;
}
.mobiletCheckout .checkoutFooter .right p {
  position: absolute;
  right: 1.2rem;
  line-height: 0.6rem;
  font-size: 0.2rem;
  color: #f9415d;
}
.mobiletCheckout .checkoutFooter .right p span {
  font-size: 0.14rem;
}
.mobiletCheckout .checkoutFooter .right button {
  border: 0;
  background: #f9415d;
  color: #fff;
  height: 0.63rem;
  display: inline-block;
  width: 1.14rem;
  background: rgba(249, 65, 93, 1);
  font-size: 0.16rem;
}
</style>
